import React, { useState, useEffect, useContext } from 'react';
import styled from 'styled-components';
import { FaUser, FaLock } from 'react-icons/fa';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import leftBackground from '../../assets/leftBackground.png';
// import rightBackground from '../../assets/rightBackground.png';
// import centerImage from '../../assets/centerImage.png';
// import loginLogo from '../../assets/Secorex publica play Final SVG.svg';
// import bottomImage from '../../assets/Fidrox png.png';

import leftBackgroundNew from '../../assets/login.png';
import rightBackground from '../../assets/rightBackground.png';
import centerImage from '../../assets/centerImage.png';
import loginLogoNew from '../../assets/login.png';
import loginLogoNewlog from '../../assets/infosys- White.svg';
import axios from 'axios';

import loginLogoNewTop from '../../assets/secorex.png';

import bottomImage from '../../assets/Fidrox png.png';


import { storeUserData } from '../../services/Storage'
import { isAuthenticated } from '../../services/Auth';
import { useNavigate } from 'react-router-dom';
import { LoginApi } from '../../services/Api';
import UsernameContext from './UsernameContext';
import Modal from 'react-modal';
import UpdatePasswordModal from './UpdatePasswordModal';
import ForgotPasswordModal from './ForgotPasswordModal';
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { FiX } from 'react-icons/fi'; // Close icon

Modal.setAppElement('#root'); // Set the app element for accessibility


const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
`;



const Container = styled.div`
  display: flex;
  height: 100vh;
  font-family: 'Segoe UI', sans-serif; /* Set font family for the whole login page */
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

// const LeftColumn = styled.div`
//   flex: 0 0 40%;
//   background: url(${leftBackground}) no-repeat center center;
//   background-size: cover;
//   display: flex;
//   flex-direction: column; /* Allows stacking elements vertically */
//   justify-content: center; /* Centers the main content */
//   align-items: center;
//   position: relative; /* To position the new image at the bottom */

//   @media (max-width: 768px) {
//     flex: 0 0 30%;
//   }
// `;
const LeftColumn = styled.div`
  flex: 0 0 70%;
  background-color: #fff;
  background-size: cover;
  display: flex;
  flex-direction: column; /* Allows stacking elements vertically */
  justify-content: center; /* Centers the main content */
  align-items: center;
  position: relative; /* To position the new image at the bottom */
  
  @media (max-width: 768px) {
    flex: 0 0 30%;
  }
`;

const CenterImage = styled.img`
  max-width: 50%;
  max-height: 50%;
`;
const LoginLogo = styled.img`
  max-width: 50%;
  max-height: 50%;
`;
const LoginLogoNew = styled.img`
  max-width: 60%;
  max-height: 60%;
`;
const LoginLogoNewLog = styled.img`
  max-width: 30%;
  max-height: 30%;
`;
const LoginLogoNewTop = styled.img`
 position: absolute; /* Position it at the bottom */
  top: 20px; /* Adjusts the distance from the bottom */
  max-width: 25%;
  max-height: 25%;
`;
// const BottomImage = styled.img`
//   position: absolute; /* Position it at the bottom */
//   bottom: 20px; /* Adjusts the distance from the bottom */
//   max-width: 22%; /* Adjust the size as needed */
//   max-height: 22%;
// `;
const BottomImage = styled.img`
  position: absolute;
    bottom: 4rem;
    max-width: 12%;
    max-height: 12%;
`;
const BottomImageNew = styled.img`
  position: absolute; /* Position it at the bottom */
  bottom: 20px; /* Adjusts the distance from the bottom */
  max-width: 12%; /* Adjust the size as needed */
  max-height: 12%;
`;

// const RightColumn = styled.div`
//   flex: 0 0 60%;
//   background: url(${rightBackground}) no-repeat center center;
//   background-size: cover;
//   display: flex;
//   justify-content: center; /* Align content to the bottom */
//   align-items: center; /* Align content to the bottom */
//   @media (max-width: 768px) {
//     flex: 0 0 70%;
//     justify-content: flex-start;
//     align-items: center;
//     padding: 1rem;
//   }
// `;
// const RightColumn = styled.div`
//   flex: 0 0 30%;
//   background-color: #183e9f;
//   background-size: cover;
//   display: flex;
//   justify-content: center; /* Align content to the bottom */
//   align-items: center; /* Align content to the bottom */
//   @media (max-width: 768px) {
//     flex: 0 0 70%;
//     justify-content: flex-start;
//     align-items: center;
//     padding: 1rem;
//   }
// `;
const RightColumn = styled.div`
  flex: 0 0 30%;
  background-color: #183e9f;
  background-size: cover;
  display: flex;
  flex-direction:column;
  gap:40px;
  justify-content: center; /* Align content to the bottom */
  align-items: center; /* Align content to the bottom */
  @media (max-width: 768px) {
    flex: 0 0 70%;
    justify-content: flex-start;
    align-items: center;
    padding: 1rem;
  }
`;


// const Card = styled.div`
//   background: #fff;
//   box-shadow: 0px 0px 50px #E3E3E3E0;
//   border-radius: 33px;
//   opacity: 1;
//   padding-top: 1rem;
//   padding-bottom: 2rem;
//   padding-left: 3.2rem;
//   padding-right: 3.2rem;

//   height: auto;
//   text-align: center;
//   width: 40%; /* Adjusted width for better responsiveness */
//   max-width: 400px; /* Added max-width for smaller screens */
//   margin-bottom: 2rem; /* Space between card and bottom */
//   @media (max-width: 768px) {
//     width: 80%;
//     padding: 2rem;
//   }
// `;
const Card = styled.div`
  background: #fff;
  box-shadow: 0px 0px 50px #E3E3E3E0;
  border-radius: 33px;
  opacity: 1;
  padding-top: 1rem;
  padding-bottom: 2rem;
  padding-left: 3.2rem;
  padding-right: 3.2rem;

  height: auto;
  text-align: center;
  width: 65%; /* Adjusted width for better responsiveness */
  max-width: 400px; /* Added max-width for smaller screens */
  margin-bottom: 2rem; /* Space between card and bottom */
  @media (max-width: 768px) {
    width: 80%;
    padding: 2rem;
  }
`;

const MainHeading = styled.h1`
  margin-top: 0px;
  color: #293495;
  text-align: center; /* Ensure the heading is centered */
`;
const BottomFooter = styled.p`
  color: #000;
  text-align: center; /* Ensure the heading is centered */
  position: absolute; /* Position it at the bottom */
bottom: 10px; /* Adjusts the distance from the bottom */
`;



const SubHeading = styled.p`
  color: #4D528D;
  font-size: 8px;
  font-weight: 500;
  font-family: 'Segoe UI', sans-serif; /* Set font family for the whole login page */
  text-align: center; /* Ensure the subheading is centered */
`;

const InputContainer = styled.div`
  position: relative;
  margin-bottom: 1rem;
`;

const Icon = styled.div`
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  color: rgba(43, 52, 151, 0.5); /* Icon color with 50% opacity */
`;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ModalContent = styled.div`
  background: #fff;
  padding: 25px;
  width: 400px;
  border-radius: 10px;
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.3);
  text-align: center;
  position: relative;
`;

const Title = styled.h2`
  color: #293495;
  margin-bottom: 20px;
  font-size: 20px;
`;


const Input = styled.input`
  width: calc(100% - 20px);
  padding: 10px;
  padding-left: 30px; /* Added padding to accommodate icon */
  border: none;
  border-bottom: 2px solid rgba(43, 52, 151, 0.5); /* Bottom border color with 50% opacity */
  background: none;
  outline: none;
  font-family: 'Segoe UI', sans-serif; /* Set font family for input fields */
  &::placeholder {
    color: rgba(43, 52, 151, 0.5); /* Placeholder color with 50% opacity */
  }
`;

const LinksContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
`;

const Link = styled.a`
  color: #293495;
  text-decoration: none;
  font-weight: 500;
  font-size: 12px;
  cursor: pointer;

`;

const Button = styled.button`
  background: linear-gradient(to right, #575FC1, #1F2884); /* Linear gradient background */
  color: #fff;
  padding: 0.5rem 1rem;
  border: 2px solid #fff;
  border-radius: 8px;
  cursor: pointer;
  width: 212px; /* Width of the button */
  height: 39px; /* Height of the button */
  box-shadow: 0px 10px 10px -5px rgba(0, 0, 0, 0.65); /* Drop shadow */
  &:disabled {
    background: gray; /* Disabled button background */
    cursor: not-allowed; /* Disabled button cursor */
  }
    
`;
const ButtonN = styled.button`
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-weight: bold;
  font-size: 14px;
  width: 48%;
  transition: 0.3s;
  &:first-child {
    background: #ccc;
    color: #000;
    &:hover {
      background: #b3b3b3;
    }
  }
  &:last-child {
    background: #293495;
    color: #fff;
    &:hover {
      background: #1f286f;
    }
  }
`;

const UpdatePasswordLink = styled.div`
  margin-top: 1rem;
  color: #293495;
  text-decoration: none;
  font-weight: 500;
  cursor: pointer;
  font-size: 12px;
`;

const ErrorMessage = styled.p`
  color: red;
  font-size: 0.9em;
`;
const EyeIcon = styled.div`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #293495;
`;
// const LinksContainer = styled.div`
//   display: flex;
//   justify-content: space-between;
//   margin-bottom: 1rem;
// `;

// const Link = styled.a`
//   color: #293495;
//   text-decoration: none;
//   font-weight: 500;
//   font-size: 12px;
//   cursor: pointer;

// `;

const PopupOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
`;

const PopupContent = styled.div`
  background: white;
  width: 500px;
  max-height: 80%;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  overflow-y: auto;
  position: relative;
  text-align: left;

  /* Scrollbar styling */
  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background: #293495;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #ff3030;
  }

  scrollbar-color: #293495 #f1f1f1;
  scrollbar-width: thin;
`;

const CloseIcon = styled(FiX)`
  position: absolute;
  top: 12px;
  right: 12px;
  cursor: pointer;
  color: #293495;
  font-size: 20px;

  &:hover {
    color: #ff3030;
  }
`;



const Login = () => {
  const [isUpdatePasswordModalOpen, setIsUpdatePasswordModalOpen] = useState(false);
  const [isForgotPasswordModalOpen, setIsForgotPasswordModalOpen] = useState(false); // State for ForgotPasswordModal


  const [isUpdatePassword, setIsUpdatePassword] = useState(false);
  const [formValues, setFormValues] = useState({
    oldPassword: '',
    newPassword: '',
    confirmNewPassword: '',
  });
  const [formErrors, setFormErrors] = useState({
    oldPassword: '',
    newPassword: '',
    confirmNewPassword: '',
  });

  const handleUpdatePassword = (e) => {
    e.preventDefault();
    let errors = {};

    if (!formValues.oldPassword.trim()) {
      errors.oldPassword = 'Old Password is required';
    }

    if (!formValues.newPassword.trim()) {
      errors.newPassword = 'New Password is required';
    }

    if (!formValues.confirmNewPassword.trim()) {
      errors.confirmNewPassword = 'Confirm New Password is required';
    }

    if (formValues.newPassword !== formValues.confirmNewPassword) {
      errors.confirmNewPassword = 'New Password and Confirm New Password must match';
    }

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }

    // Handle the form submission
    console.log('Form submitted', formValues);
    setIsUpdatePasswordModalOpen(false);

  };


  const [username, setUsernameLocal] = useState('');
  const [password, setPassword] = useState('');
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [inputs, setInputs] = useState({
    username: "",
    password: "",
  })
  const { setUsername } = useContext(UsernameContext); // Access setUsername function from context

  const initialStateErrors = {
    username: { required: false },
    password: { required: false },
  };
  const navigate = useNavigate(); // Initialize useNavigate hook

  const [errors, setErrors] = useState(initialStateErrors);
  // const [isAuthenticated, setIsAuthenticated] = useState(false);


  const handleInput = (event) => {
    setInputs({ ...inputs, [event.target.name]: event.target.value })
    const { name, value } = event.target;
    setFormValues({ ...formValues, [name]: value });
    setFormErrors({ ...formErrors, [name]: '' });

  }

  const handleSubmit = (event) => {
    console.log(inputs);
    event.preventDefault();
    let errors = initialStateErrors;
    let hasError = false;

    if (inputs.username == "") {
      errors.username.required = true;
      hasError = true;
    }
    if (inputs.password == "") {
      errors.password.required = true;
      hasError = true;
    }
    if (!hasError) {
      const payload = {
        username: inputs.username,
        password: inputs.password,
        privacyPolicyAccepted: isChecked  // Send true/false
      };
      LoginApi(payload).then(async (response) => {
        console.log(response)
        //storeUserData(response.data.token);
        //localStorage.setItem('token', response.data);
        // localStorage.setItem('isAuthenticated', 'true');
        if (response.data.statusMessage == "Please change the default Password") {
          toast.error("Please change the default Password")
          return
        }
        if (response.data.statusMessage == "Please accept Privacy Policy") {
          toast.error("Please Accept Privacy Policy")
          return
        }
        if (response.data.statusCode == 0) {
          localStorage.setItem('isAuthenticated', 'true');
          localStorage.setItem('loginUsername', inputs.username);
          localStorage.setItem('token', response.data.token);


          setUsername(inputs.username); // Set username to context

          const empRes = await axios.get(`/Employee/Employee/${inputs.username}`);
          const empId = empRes.data.id;
  
          // Now call GetRoles API with empId
          const rolesRes = await axios.get(`/RoleManagement/GetRoles`, { params: { empId } });
          const roles = rolesRes.data;

  
          console.log('Roles:', rolesRes.data);
          if (roles && roles.length > 0) {
            const firstRole = roles[0];
            navigate(firstRole.defaultUrl);

          }
          else {
            navigate('/layut/Dashboard/Dashboard');

          }
          

        }
        else {
          localStorage.setItem('isAuthenticated', 'false');
          toast.error('Login Failed. Please check your credentials.');
          console.log('Login Failed', response.data);
        }

      }).catch((err) => {
        console.log(err);
        localStorage.setItem('isAuthenticated', 'false');
        toast.error('An error occurred during login. Please try again.');

        //  if (err.code="ERR_BAD_REQUEST") {
        //       setErrors({...errors,custom_error:"Invalid Credentials."})
        //  }

      })
    }
    setErrors({ ...errors });

  }
  const handleUpdatePasswordLinkClick = () => {
    if (inputs.username === '') {
      setErrors({ ...errors, username: { required: true } });
    } else {
      setIsUpdatePasswordModalOpen(true);
    }
  };


  const handleForgotPasswordLinkClick = () => {
    setIsForgotPasswordModalOpen(true);
  };

  const [formData, setFormData] = useState({
    usernameR: "",
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [showPassword, setShowPassword] = useState({ old: false, new: false, confirm: false });
  const [error, setError] = useState("");
  const [showModal, setShowModal] = useState(false);
  const togglePasswordView = (field) => {
    setShowPassword((prev) => ({ ...prev, [field]: !prev[field] }));
  };

  const handleChangePassword = () => {
    setFormData({
      usernameR: "", // Reset username field
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
    }); setError("");
    setShowModal(true);
  };

  const handleClose = () => {
    setFormData({ usernameR: "", oldPassword: "", newPassword: "", confirmPassword: "" });
    setError("");
    setShowModal(false);
  };
  const validateEmail = (email) => {
    return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);
  };

  const handleUpdate = async () => {
    if (!validateEmail(formData.usernameR)) {
      setError("Please enter a valid email address.");
      return;
    }
    if (formData.newPassword.length < 6) {
      setError("New password must be at least 6 characters long.");
      return;
    }
    if (formData.newPassword !== formData.confirmPassword) {
      setError("New password and confirm password must match.");
      return;
    }

    const requestData = {
      username: formData.usernameR,
      oldPassword: formData.oldPassword,
      newPassword: formData.newPassword,
    };
    try {
      const { usernameR, oldPassword, newPassword } = formData;

      const url = `/User/UpdatePassword/${encodeURIComponent(usernameR)},${encodeURIComponent(oldPassword)},${encodeURIComponent(newPassword)}`;

      const changePassword = await axios.put(url);

      console.log("changePassword", changePassword);
      toast.success(changePassword.data)
    } catch (error) {
      console.error("Error updating password:", error);
      toast.error(error)

    }

    console.log("API Request Data:", requestData);
    handleClose();
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const handleSSOLogin = (event) => {
    event.preventDefault();

    let errors = { ...initialStateErrors };
    let hasError = false;

    const { username, password } = inputs;

    // Case: If both fields are empty, allow empty values
    if (username === "" && password === "") {
      errors.username.required = false;
      errors.password.required = false;
      hasError = false;


      // No error
    } else {
      // If one of them is empty, show error
      if (username === "") {
        errors.username.required = true;
        hasError = true;
      }
      if (password === "") {
        errors.password.required = true;
        hasError = true;
      }
    }

    if (hasError) {
      setErrors(errors);
      return;
    }

    const SSO_API_URL = `${window.APP_CONFIG.SECONDARY_API_URL}/User/SSOLogin`;

    axios.get(SSO_API_URL, {
      params: {
        username,
        password
      },
      withCredentials: true
    })
      .then(response => {
        if (response.status === 204) {
          toast.error("Invalid credentials are entered");
          localStorage.setItem('isAuthenticated', 'false');
          return;
        }

        const data = response.data;
        if (data && data.username) {
          console.log("Logged in as:", data.username);
          localStorage.setItem('isAuthenticated', 'true');
          localStorage.setItem('loginUsername', data.username);
          localStorage.setItem('token', data.token);
          setUsername(data.username);
          navigate('/layout/Dashboard/Dashboard');
        } else {
          localStorage.setItem('isAuthenticated', 'false');
          toast.error("SSO login failed.");
        }
      })
      .catch(error => {
        console.error("Error during SSO login:", error);
        toast.error("Something went wrong. Please try again.");
      });
    setErrors({ ...errors });

  };




  // return (
  //   <Container>
  //     <ToastContainer />
  //     <LeftColumn>
  //       <LoginLogo src={loginLogo} alt="Centered" />
  //       <BottomImage src={bottomImage} alt="Bottom Centered" />
  //     </LeftColumn>
  //     <RightColumn>
  //       <Card>
  //       <form onSubmit={handleSubmit}>

  //         <MainHeading>Welcome</MainHeading>
  //         {/* <SubHeading>Lorem Ipsum Dolor Sit Amet, Consetetur Sadipscing Elitr, Sed Diam Nonumy Eirmod Tempor Invidunt Ut Labore Et Dolore Magna Aliquyam Erat, Sed Diam Voluptua. At</SubHeading> */}
  //         <InputContainer>
  //           <Icon><FaUser /></Icon>
  //           <Input
  //             type="text"
  //             placeholder="User Name"
  //             name="username"
  //             onChange={handleInput}            />
  //         </InputContainer>
  //         {errors.username.required && <ErrorMessage>Username is required</ErrorMessage>}

  //         <InputContainer>
  //           <Icon><FaLock /></Icon>
  //           <Input
  //             type="password"
  //             placeholder="Password"
  //             name="password"
  //             onChange={handleInput}            />
  //         </InputContainer>
  //         {errors.password.required && <ErrorMessage>Password is required</ErrorMessage>}

  //         <LinksContainer>
  //         <Link onClick={handleForgotPasswordLinkClick}>Forgot Password?</Link>
  //         <Link href="#">Sign In With Azure Directory</Link>
  //         </LinksContainer>
  //         {/* <Button onClick={handleLogin} disabled={isButtonDisabled}>Login</Button> */}
  //         <Button type='submit' >Login</Button>
  //         {/* <UpdatePasswordLink onClick={handleUpdatePasswordLinkClick}>Update Password</UpdatePasswordLink> */}

  //         </form>
  //       </Card>
  //     </RightColumn>
  //     <UpdatePasswordModal
  //       isOpen={isUpdatePasswordModalOpen}
  //       setIsOpen={setIsUpdatePasswordModalOpen}
  //       handleUpdatePassword={handleUpdatePassword}
  //       username={inputs.username}
  //     />
  //           <ForgotPasswordModal
  //       isOpen={isForgotPasswordModalOpen}
  //       setIsOpen={setIsForgotPasswordModalOpen}
  //     />

  //   </Container>
  // );
  const [isChecked, setIsChecked] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [policyContent, setPolicyContent] = useState('');

  const handlePrivacyPolicyClick = async (e) => {
    e.preventDefault(); // prevent link navigation
    try {
      const response = await axios.get('/User/GetPrivacyPolicyContent');
      setPolicyContent(response.data);
      setShowPopup(true);
    } catch (error) {
      setPolicyContent('Failed to load privacy policy.');
      setShowPopup(true);
    }
  };

  return (
    <Container>
      <ToastContainer />
      <LeftColumn>
        <LoginLogoNewTop src={loginLogoNewTop} alt="Centered" />
        <LoginLogoNew src={loginLogoNew} alt="Centered" />
        <BottomImage src={bottomImage} alt="Bottom Centered" />
        <BottomFooter>
          Copyright © 2024 <a href="https://www.fidroxtech.com/" style={{ textDecoration: 'none' }}>Fidrox Technologies Private Limited</a>, Bangalore, INDIA. All rights reserved.
        </BottomFooter>

      </LeftColumn>
      <RightColumn>
        <LoginLogoNewLog src={loginLogoNewlog} alt="Centered" />
        <Card>
          <form onSubmit={handleSubmit}>

            <MainHeading>Welcome</MainHeading>
            {/* <SubHeading>Lorem Ipsum Dolor Sit Amet, Consetetur Sadipscing Elitr, Sed Diam Nonumy Eirmod Tempor Invidunt Ut Labore Et Dolore Magna Aliquyam Erat, Sed Diam Voluptua. At</SubHeading> */}
            <InputContainer>
              <Icon><FaUser /></Icon>
              <Input
                type="text"
                placeholder="User Name"
                name="username"
                 autoComplete="off"
                autoSave='off'
                onChange={handleInput} />
            </InputContainer>
            {errors.username.required && <ErrorMessage>Username is required</ErrorMessage>}

            <InputContainer>
              <Icon><FaLock /></Icon>
              <Input
                type="password"
                placeholder="Password"
                name="password"
                onChange={handleInput} />
            </InputContainer>
            {errors.password.required && <ErrorMessage>Password is required</ErrorMessage>}

            <LinksContainer>
              <Link onClick={handleForgotPasswordLinkClick}>Forgot Password?</Link>
              {/* <Link onClick={handleChangePassword}>Change Password</Link> */}
            </LinksContainer>
            {/* <Button onClick={handleLogin} disabled={isButtonDisabled}>Login</Button> */}
            <div style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
              <input
                type="checkbox"
                id="privacyPolicy"
                checked={isChecked}
                onChange={(e) => setIsChecked(e.target.checked)}
              />
              <label htmlFor="privacyPolicy" style={{ marginLeft: "8px" }}>
                I agree to the <a onClick={handlePrivacyPolicyClick} style={{ color: 'blue', cursor: 'pointer', textDecoration: 'underline' }}>Privacy Policy</a>
              </label>
              {showPopup && (
                <PopupOverlay>
                  <PopupContent>
                    <CloseIcon onClick={() => setShowPopup(false)} />
                    <div dangerouslySetInnerHTML={{ __html: policyContent }} />
                  </PopupContent>
                </PopupOverlay>
              )}
            </div>
            <Button type='submit' >Login</Button>


            {/* <UpdatePasswordLink onClick={handleUpdatePasswordLinkClick}>Update Password</UpdatePasswordLink> */}

          </form>
          <Button style={{ marginTop: '10px' }} onClick={handleSSOLogin}>Windows Login</Button>

        </Card>
      </RightColumn>
      <UpdatePasswordModal
        isOpen={isUpdatePasswordModalOpen}
        setIsOpen={setIsUpdatePasswordModalOpen}
        handleUpdatePassword={handleUpdatePassword}
        username={inputs.username}
      />
      <ForgotPasswordModal
        isOpen={isForgotPasswordModalOpen}
        setIsOpen={setIsForgotPasswordModalOpen}
      />

      {showModal && <ModalOverlay>
        <ModalContent>
          <Title>Change Password</Title>
          <InputContainer>
            <Icon>@</Icon>
            <Input
              type="email"
              name="usernameR"
              placeholder="Email"
              value={formData.usernameR}
              onChange={handleChange}
            />
          </InputContainer>
          <InputContainer>
            <Icon>
              <FaLock />
            </Icon>
            <Input
              type={showPassword.old ? "text" : "password"}
              name="oldPassword"
              placeholder="Old Password"
              value={formData.oldPassword}
              onChange={handleChange}
            />
            <EyeIcon onClick={() => togglePasswordView("old")}>
              {showPassword.old ? <FaEyeSlash /> : <FaEye />}
            </EyeIcon>
          </InputContainer>
          <InputContainer>
            <Icon>
              <FaLock />
            </Icon>
            <Input
              type={showPassword.new ? "text" : "password"}
              name="newPassword"
              placeholder="New Password"
              value={formData.newPassword}
              onChange={handleChange}
            />
            <EyeIcon onClick={() => togglePasswordView("new")}>
              {showPassword.new ? <FaEyeSlash /> : <FaEye />}
            </EyeIcon>
          </InputContainer>
          <InputContainer>
            <Icon>
              <FaLock />
            </Icon>
            <Input
              type={showPassword.confirm ? "text" : "password"}
              name="confirmPassword"
              placeholder="Confirm Password"
              value={formData.confirmPassword}
              onChange={handleChange}
            />
            <EyeIcon onClick={() => togglePasswordView("confirm")}>
              {showPassword.confirm ? <FaEyeSlash /> : <FaEye />}
            </EyeIcon>
          </InputContainer>
          {error && <ErrorMessage>{error}</ErrorMessage>}
          <ButtonContainer>
            <ButtonN onClick={handleClose}>Cancel</ButtonN>
            <ButtonN onClick={handleUpdate}>Update</ButtonN>
          </ButtonContainer>
        </ModalContent>
      </ModalOverlay>
      }

    </Container>
  );
};

export default Login;
